module.exports = __webpack_public_path__ + "static/media/uploadMedia.760a6ce4.svg";